import { render, staticRenderFns } from "./IntentExamplesHeader.vue?vue&type=template&id=07aaf57e&"
import script from "./IntentExamplesHeader.vue?vue&type=script&lang=js&"
export * from "./IntentExamplesHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports